import AppConstants from "../../../../../config/app.constants";
import BillableEventsBaseController from "../common/billable_events.base.controller";

class BillableEventsCreateController extends BillableEventsBaseController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, $stateParams, $location, Modal, BillableEventsService) {

        super(Auth, $state, User, BillableEventsService, Modal, $translate, $stateParams)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.BillableEventsService = BillableEventsService;

        this.defaultModel = {
            entryTypeObj: {
                totalRecords: 0,
                entryTypes: [],
                loading: false
            },
            isCreate: false,
            branchId: User.getUser().branchId,
            entryType: null,
            billingCategory: null,
            description: null,
            errorMessage: '',
            billingCategoryObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            billableEventObj: {
                totalRecords: 0,
                eventList: [],
                loading: false
            },
            generalLedgerCode: null,
            createdByOptions: null,
            inventoryType: null,
        }
        this.model = angular.copy(this.defaultModel);
        this.billableEventList = [
            {
                label: 'Pre Bill',
                value: 'pre-bill'
            },
            {
                label: 'Post Bill',
                value: 'post-bill'
            },
            {
                label: 'Shipment Delivery',
                value: 'shipment-delivered'
            },
            {
                label: 'Shipment Pickup',
                value: 'shipment-pickup'
            },
            {
                label: 'ATM Load Service',
                value: 'atm-load-service'
            },
            {
                label: 'ATM Residual Count',
                value: 'atm-residual-count'
            },
            {
                label: 'ATM Order Pack',
                value: 'atm-order-pack'
            },
            {
                label: 'ATM Residual Deposit',
                value: 'atm-residual-deposit'
            },
            {
                label: 'Delivery Order Pack',
                value: 'delivery-order-pack'
            },
            {
                label: 'Pickup Deposit',
                value: 'pickup-deposit'
            },
            {
                label: 'Service Ticket Completed',
                value: 'service-ticket-completed'
            },
            {
                label: 'Part Charge',
                value: 'part-charge'
            },
            {
                label: 'ATM Deposit Pickup',
                value: 'atm-deposit-pickup'
            },
            {
                label: 'ATM Deposit Count',
                value: 'atm-deposit-count'
            },
            {
                label: 'ATM Load Can\'t',
                value: 'atm-load-cant'
            },
            {
                label: 'Shipment Delivery Can\'t',
                value: 'shipment-delivery-cant'
            },
            {
                label: 'Coin Pickup',
                value: 'coin-pickup'
            },
            {
                label: 'Coin Delivery',
                value: 'coin-delivery'
            },
            {
                label: 'Service Ticket Incomplete',
                value: 'service-ticket-incomplete'
            },
            {
                label: 'Service Ticket Cancelled',
                value: 'service-ticket-cancelled'
            },
            {
                label: 'ATM Cash Delivery',
                value: 'atm-cash-delivery'
            },
            {
                label: 'ATM Cash Pickup',
                value: 'atm-cash-pickup'
            },
            {
                label: 'Deposit Count',
                value: 'deposit-count'
            },
            {
                label: 'Stop Completed',
                value: 'stop-completed'
            },
            {
                label: 'Coin Conversion',
                value: 'coin-conversion'
            },
            {
                label: 'Order Create',
                value: 'order-create'
            }
        ]
        this.createdByOptions = [
            { label: 'Customer User', value: 'CUSTOMER_USER' },
            { label: 'Web User', value: 'WEB_USER' }
        ]
        this.inventoryTypeOptions = [
            { label: 'Regular', value: 'REGULAR' },
            { label: 'Emergency', value: 'EMERGENCY' }
        ]
    }

    $onInit() {
        this.loadData();
        this.getBillingCategory('', 0);
    }

    // getAllEntryTypes(searchKey, offset) {
    //     searchKey = searchKey || '';

    //     this.model.entryTypeObj.loading = true;
    //     this.Service.getAllEntryTypes(searchKey, AppConstants.defaultPageLimit, offset)
    //         .then((data) => {
    //             if (offset === 0 || offset == undefined) {
    //                 this.model.entryTypeObj.totalRecords = data.total;
    //                 this.model.entryTypeObj.entryTypes = this.eventMap(data.results);
    //             }
    //             else {
    //                 const entryTypes = this.eventMap(data.results);
    //                 this.model.entryTypeObj.entryTypes = this.model.entryTypeObj.entryTypes.concat(entryTypes);
    //             }
    //         })
    //         .catch((err) => {
    //             this.Modal.errorModal(err.data.message);
    //         })
    //         .finally(() => {
    //             this.model.entryTypeObj.loading = false;
    //         })
    // }

    // eventMap(events) {
    //     return events.map((data) => {
    //         return {
    //             Key: this.translateMessage(data.entryType),
    //             Value: data.entryType
    //         }
    //     });
    // }

    eventMap(events) {
        return events.map((data) => {
            return {
                Key: this.translateMessage(data.value),
                Value: data.value
            }
        });
    }

    isOrderCreateEvent() {
        return this.model.entryType &&
            this.model.entryType.Value === 'order-create';
    }

    submit() {
        this.model.isCreate = true;
        delete this.model.errorMessage;

        this.Service.create({
            type: this.model.entryType.Value,
            billingCategoryId: this.model.billingCategory.Value,
            description: this.model.description,
            branchId: this.model.branchId,
            event: this.model.entryType.Key,
            createdBy: this.model.createdBy,
            inventoryType: this.model.inventoryType,
            generalLedgerCode: this.model.generalLedgerCode
        })
            .then(() => {
                this.askCreate().then(() => this.loadData())
            })
            .catch((err) => {
                err.data.errors.map((e) => {
                    this.model.errorMessage = e.message;
                })
            })
            .finally(() => {
                this.model.isCreate = false;
            })
    }

    translateMessage(key) {
        if (!key) return;
        return this.$translate.instant('entry_type.' + key);
    }

    loadData() {
        this.loadAllEvents();
    }

    reset() {
        // this.model = angular.copy(this.defaultModel);
        this.model.entryType = null;
        this.model.billingCategory = null;
        this.model.description = null;
        this.model.createdBy = null;
        this.model.inventoryType = null;
        this.model.errorMessage = '';
        this.clearErrors();
    }

    getBillingCategory(searchKey, offset) {
        searchKey = searchKey || '';    

        this.model.billingCategoryObj.loading = true;
        this.Service.getBillingCategory(searchKey, AppConstants.defaultPageLimit, offset)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.model.billingCategoryObj.totalRecords = data.total;
                    this.model.billingCategoryObj.results = this.billingCategoryMap(data.results);
                }
                else {
                    const results = this.billingCategoryMap(data.results);
                    this.model.billingCategoryObj.results = this.model.billingCategoryObj.results.concat(results);
                }
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.billingCategoryObj.loading = false;
            })
    }

    billingCategoryMap(events) {
        return events.map((data) => {
            return {
                Key: data.categoryName,
                Value: data.billingCategoryId
            }
        });
    }

    loadAllEvents() {
        this.model.billableEventObj.loading = true;

        this.BillableEventsService.all(null, 0, 100)
            .then((data) => {
                this.model.billableEventObj.eventList = data.results;
                this.model.billableEventObj.totalRecords = data.total;

                for (let i = 0; i < this.model.billableEventObj.totalRecords; i++) {
                    this.billableEventList = this.billableEventList.filter((item) => {
                        return this.model.billableEventObj.eventList[i].type != item.value;
                    });
                }

                this.model.entryTypeObj.totalRecords = this.billableEventList.length;
                this.model.entryTypeObj.entryTypes = this.eventMap(this.billableEventList);
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.billableEventObj.loading = false;
            })
    }

}
export default BillableEventsCreateController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billable_events/create/billable_events.create.controller.js